/*
 * Palo Alto Theme
 *
 * Use this file to add custom Javascript to Palo Alto.  Keeping your custom
 * Javascript in this fill will make it easier to update Palo Alto. In order
 * to use this file you will need to open layout/theme.liquid and uncomment
 * the custom.js script import line near the bottom of the file.
 */


(function() {
    // Add custom code below this line


    // Blog product checkout button //
    function bundleAddToCartProduct(currentThis, dynamicData) {

        $.ajax({
            url: "/cart/add.js",
            type: "POST",
            data: {
                items: dynamicData
            },
            dataType: "json",
            success: function(data) {
                currentThis.removeClass('untouchable');
                window.location.replace("/checkout");
            },
            error: function(jqXHR, textStatus, errorThrown) {
                currentThis.removeClass('untouchable');
                if (jqXHR.status == 400) {
                    alert(jqXHR.responseJSON.message);
                }
                if (jqXHR.status == 422) {
                    alert(jqXHR.responseJSON.description);
                }
            }
        });
    }

    $('#lp_addToCart_btn, #lp_addToCart_btn_2').click(function() {
        var lpvariantId = $(this).attr('var-id'),
            quantity = 1;
        var updateItems = [];
        var currentThis = $(this);
        updateItems.push({
            "id": lpvariantId,
            "quantity": quantity
        });
        $.ajax({
            type: "POST",
            url: '/cart/clear.js',
            success: function() {
                bundleAddToCartProduct(currentThis, updateItems);
                currentThis.addClass('is-loading');
            },
            dataType: 'json'
        });
    });
    // End //  

    // Cart progress bar fix for subscription products
    function handleCartAdded(event) {
        console.log('Cart trigger!');
        const sellingPlanSubscriptionElement = document.querySelector('.cart-drawer__items .cart__item__selling-plan-subscription');
        const cartMessageElement = document.querySelector('.cart-drawer__message');

        if (sellingPlanSubscriptionElement && cartMessageElement && !cartMessageElement.classList.contains('is-success')) {
            cartMessageElement.classList.add('is-success');
            document.querySelector('.cart__message__default').classList.add('is-hidden');

            const progressElements = document.querySelectorAll('.cart__message__progress');
            progressElements.forEach(progressElement => {
                progressElement.classList.add('is-hidden');
                progressElement.setAttribute('value', '100');
                progressElement.setAttribute('max', '100');
                progressElement.style.setProperty('--progress-width', '100%');
            });
        }

        // CartDrawer Upgrade To Subscription Start
        let subscriptionButtons = document.querySelectorAll('.subscription-button');
        subscriptionButtons.forEach(function(button) {
            if (button.getAttribute('data-click-added') === null) {
                button.setAttribute('data-click-added', '');
                button.addEventListener('click', function() {
                    let optionsContainer = this.nextElementSibling;
                    let selectElement = optionsContainer.querySelector('.subscription-select');
                    optionsContainer.style.display = 'block';
                    selectElement.style.display = 'block';
                    this.style.display = 'none';
                    this.classList.add('is-loading');
                    selectElement.showPicker();
                });
            }
        });

        let subscriptionSelects = document.querySelectorAll('.subscription-select');
        subscriptionSelects.forEach(function(select) {
            select.setAttribute('data-initial-value', select.value);

            select.addEventListener('change', function() {
                let initialValue = this.getAttribute('data-initial-value');

                if (this.value !== initialValue) {
                    let cartItemID = this.closest('.upgrade-to-subscription').getAttribute('data-line-item-id');
                    let selectedPlanID = this.value;
                    let variantId = this.querySelector('option:checked').getAttribute('data-variant-id');
                    updateCart({
                        id: cartItemID,
                        quantity: 0
                    }, cartItemID, function() {
                        addToCart(variantId, 1, selectedPlanID);
                    });
                    this.style.display = 'none';
                    this.closest('.upgrade-to-subscription').querySelector('.subscription-button').style.display = 'block';
                    this.closest('.subscription-options-container').style.display = 'none';

                    this.setAttribute('data-initial-value', this.value);
                }
            });
        });

        function updateCart(formData, cartItemID, callback) {
            $.ajax({
                url: '/cart/change.js',
                type: 'POST',
                data: formData,
                dataType: 'json',
                success: function(data) {
                    if (callback) callback();
                },
                error: function(jqXHR, textStatus, errorThrown) {
                    console.error('Error updating cart:', jqXHR.responseJSON);
                }
            });
        }

        function addToCart(variantId, quantity, sellingPlanId) {
            let items = [{
                id: variantId,
                quantity: quantity,
                selling_plan: sellingPlanId
            }];

            $.ajax({
                url: '/cart/add.js',
                type: 'POST',
                data: {
                    items: items
                },
                dataType: 'json',
                success: function(data) {
                    document.dispatchEvent(new CustomEvent('updateCartDrawer'));
                },
                error: function(jqXHR, textStatus, errorThrown) {
                    console.error('Error adding item to cart:', jqXHR.responseJSON);
                }
            });
        }
        // CartDrawer Upgrade To Subscription End
    }

    document.addEventListener('theme:cart:added', handleCartAdded);
    document.addEventListener('theme:cart:open', handleCartAdded);

    // End


    // End of upsell cart functionality

    // Read More Methods Start
    const lockScrollReadMore = () => {
        let scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
        document.body.style.overflow = 'hidden';
        document.body.style.paddingRight = scrollbarWidth + 'px';
        header.style.paddingRight = scrollbarWidth + 'px';
        document.body.setAttribute('data-scroll-lock-saved-inline-overflow-property', '');
        document.body.setAttribute('data-scroll-lock-saved-inline-overflow-y-property', '');
        document.body.setAttribute('data-scroll-lock-locked', 'true');
        document.body.setAttribute('data-scroll-lock-filled-gap', 'true');
        document.body.setAttribute('data-scroll-lock-current-fill-gap-method', 'padding');
        document.documentElement.setAttribute('data-scroll-lock-locked', '');
    }

    const unlockScrollReadMore = () => {
        document.body.style.overflow = '';
        document.body.style.paddingRight = '';
        header.style.paddingRight = '';
        document.body.removeAttribute('data-scroll-lock-saved-inline-overflow-property');
        document.body.removeAttribute('data-scroll-lock-saved-inline-overflow-y-property');
        document.body.removeAttribute('data-scroll-lock-locked');
        document.body.removeAttribute('data-scroll-lock-filled-gap');
        document.body.removeAttribute('data-scroll-lock-current-fill-gap-method');
        document.documentElement.removeAttribute('data-scroll-lock-locked');
    }
    // Read More Methods End

    // Upsell Cart Methods Start
    const lockScrollUpsell = () => {
        let scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
        document.body.style.overflow = 'hidden';
        document.body.style.paddingRight = scrollbarWidth + 'px';
        document.body.setAttribute('data-scroll-lock-saved-inline-overflow-property', '');
        document.body.setAttribute('data-scroll-lock-saved-inline-overflow-y-property', '');
        document.body.setAttribute('data-scroll-lock-locked', 'true');
        document.body.setAttribute('data-scroll-lock-filled-gap', 'true');
        document.body.setAttribute('data-scroll-lock-current-fill-gap-method', 'padding');
        document.documentElement.setAttribute('data-scroll-lock-locked', '');
        document.body.classList.add('js-drawer-open');
    };

    const unlockScrollUpsell = () => {
        document.body.style.overflow = '';
        document.body.style.paddingRight = '';
        document.body.removeAttribute('data-scroll-lock-saved-inline-overflow-property');
        document.body.removeAttribute('data-scroll-lock-saved-inline-overflow-y-property');
        document.body.removeAttribute('data-scroll-lock-locked');
        document.body.removeAttribute('data-scroll-lock-filled-gap');
        document.body.removeAttribute('data-scroll-lock-current-fill-gap-method');
        document.documentElement.removeAttribute('data-scroll-lock-locked');
        document.body.classList.remove('js-drawer-open');
    };

    const getBundleProductData = (dataIndex, upsellCase, addToCartButton) => {
        let bundleProductItem = document.querySelector('.bundle_product_options .bundle_prod_item[data-index="' + dataIndex + '"]');
        if (!bundleProductItem) {
          bundleProductItem = document.querySelector('.bundle_product_options .bundle_prod_item[data-index="0"]');
        }
        if (bundleProductItem) {
            const dataId = bundleProductItem.getAttribute('data-id');
            const sellingPlanSelect = bundleProductItem.querySelector('.product-single__selling_plans');
            const sellingPlanId = sellingPlanSelect && sellingPlanSelect.selectedOptions.length > 0 ? sellingPlanSelect.selectedOptions[0].getAttribute('data-selling-plan-id') : null;
            if (upsellCase == 'upsell_enabled') {
                storeOriginalFormInputsUpsell();
                updateFormInputsUpsell(dataId, sellingPlanId);
                addToCartButton.setAttribute('data-upsell-drawer-click', true);
                addToCartButton.click();
                restoreOriginalFormInputsUpsell();
            } else {
                addToCart(dataId, 1, sellingPlanId, addToCartButton);
            }
        }
    };

    const addToCart = (variantId, quantity, sellingPlanId, addToCartButton) => {
        let item = {
            id: variantId,
            quantity: quantity
        };

        if (sellingPlanId) {
            item.selling_plan = sellingPlanId;
        }

        $.ajax({
            url: '/cart/add.js',
            type: 'POST',
            data: {
                items: [item]
            },
            dataType: 'json',
            success: (data) => {
                addToCartButton.setAttribute('data-upsell-drawer-click', true);
                addToCartButton.click();
            },
            error: (jqXHR, textStatus, errorThrown) => {
                console.error('Error adding item to cart:', jqXHR.responseJSON);
            }
        });
    };

    const updateFormInputsUpsell = (id, sellingPlanId) => {
        const upsellForm = document.querySelector('form[data-upsell-selector="upsell_additional_enabled"], form[data-upsell-selector="upsell_enabled"]');
        const idInput = upsellForm.querySelector('input[name="id"][data-product-select]');
        if (idInput) {
            idInput.value = id;
        }
        const sellingPlanInput = upsellForm.querySelector('input[name="selling_plan"]');
        if (sellingPlanId === '') {
            if (sellingPlanInput) {
                sellingPlanInput.remove();
            }
        } else {
            if (sellingPlanInput) {
                sellingPlanInput.value = sellingPlanId;
            } else {
                const newSellingPlanInput = document.createElement('input');
                newSellingPlanInput.type = 'hidden';
                newSellingPlanInput.name = 'selling_plan';
                newSellingPlanInput.value = sellingPlanId;
                upsellForm.appendChild(newSellingPlanInput);
            }
        }
    };

    const storeOriginalFormInputsUpsell = () => {
        const upsellForm = document.querySelector('form[data-upsell-selector="upsell_additional_enabled"], form[data-upsell-selector="upsell_enabled"]');
        const idInput = upsellForm.querySelector('input[name="id"][data-product-select]');
        const sellingPlanInput = upsellForm.querySelector('input[name="selling_plan"]');
    
        upsellForm.setAttribute('data-original-id', idInput ? idInput.value : '');
        upsellForm.setAttribute('data-original-selling-plan', sellingPlanInput ? sellingPlanInput.value : '');
    };

    const restoreOriginalFormInputsUpsell = () => {
        const upsellForm = document.querySelector('form[data-upsell-selector="upsell_additional_enabled"], form[data-upsell-selector="upsell_enabled"]');
        const originalId = upsellForm.getAttribute('data-original-id');
        const originalSellingPlan = upsellForm.getAttribute('data-original-selling-plan');
    
        const idInput = upsellForm.querySelector('input[name="id"][data-product-select]');
        if (idInput) {
            idInput.value = originalId;
        }
    
        const sellingPlanInput = upsellForm.querySelector('input[name="selling_plan"]');
        if (originalSellingPlan === '') {
            if (sellingPlanInput) {
                sellingPlanInput.remove();
            }
        } else {
            if (sellingPlanInput) {
                sellingPlanInput.value = originalSellingPlan;
            } else {
                const newSellingPlanInput = document.createElement('input');
                newSellingPlanInput.type = 'hidden';
                newSellingPlanInput.name = 'selling_plan';
                newSellingPlanInput.value = originalSellingPlan;
                upsellForm.appendChild(newSellingPlanInput);
            }
        }
    };
    // Upsell Cart Methods End

    // Subscription Selector Methods Start
    const toggleClass = (element, className, condition) => {
        condition ? element.classList.add(className) : element.classList.remove(className);
    };

    const updateAttribute = (element, attributeName, value) => {
        element.setAttribute(attributeName, value);
    };

    const updateFormInputs = (form, id, sellingPlanId) => {
        const idInput = form.querySelector('input[name="id"][data-product-select]');
        if (idInput) {
            idInput.value = id;
        }

        const sellingPlanInput = form.querySelector('input[name="selling_plan"]');
        if (sellingPlanId === '') {
            if (sellingPlanInput) {
                sellingPlanInput.remove();
            }
        } else {
            if (sellingPlanInput) {
                sellingPlanInput.value = sellingPlanId;
            } else {
                const newSellingPlanInput = document.createElement('input');
                newSellingPlanInput.type = 'hidden';
                newSellingPlanInput.name = 'selling_plan';
                newSellingPlanInput.value = sellingPlanId;
                form.appendChild(newSellingPlanInput);
            }
        }
    };

    const toggleSaveUpToMessage = (element, showSaveUpElement) => {
        const saveUpToElement = element.closest('form').querySelector('.subscription-widget__item-save-up-to');
        const savingPriceElement = element.closest('form').querySelector('.subscription-widget__subscription-saving-price');

        if (showSaveUpElement) {
            saveUpToElement.classList.remove('subscription-widget__hidden');
            savingPriceElement.classList.add('subscription-widget__hidden');
        } else {
            saveUpToElement.classList.add('subscription-widget__hidden');
            savingPriceElement.classList.remove('subscription-widget__hidden');
        }
    }

    const updatePrice = (element, price) => {
        const priceSpan = element.querySelector('.subscription-widget__item-price');
        const addToCartPriceElement = element.closest('form').querySelector('.product__submit__buttons button span[data-product-price]');

        if (priceSpan && addToCartPriceElement) {
            priceSpan.textContent = price;
            addToCartPriceElement.textContent = price;
        }
    };

    const updateServingPrice = (element) => {
        const priceString = element.getAttribute('data-price');
        const planName = element.getAttribute('data-index');
        const newPrice = getServingPrice(priceString, planName);
        const priceClass = (planName > 0 && planName < 4) ? 'subscribe' : 'one-time'

        const servingPriceElement = element.closest('.subscription-widget').querySelector('.subscription-widget__serving-price.'+priceClass);
        if (servingPriceElement) {
            servingPriceElement.textContent = newPrice;
        } else {
            console.error('Could not find .subscription-widget__serving-price element');
        }
    };

    const updateFormDataIndex = (form, dataIndex) => {
        form.setAttribute('data-selected-item-index', dataIndex);
    }


    const getServingPrice = (priceString, planName) => {
        const regex = /([^\d.,]*)([\d.,]+)([^\d]*)/;
        const match = priceString.match(regex);
    
        if (match) {
            let currencySymbol = match[1];
            let price = match[2];
            const currencySymbolAfter = match[3];
    
            if (currencySymbolAfter) { 
                currencySymbol += currencySymbolAfter;
            }
    
            const lastCommaIndex = price.lastIndexOf(',');
            const lastPeriodIndex = price.lastIndexOf('.');
    
            let thousandsSeparator = ',';
            let decimalSeparator = '.';
            if (lastCommaIndex > lastPeriodIndex) {
                thousandsSeparator = '.';
                decimalSeparator = ',';
            }
    
            price = price.split(thousandsSeparator).join('');
            price = price.replace(decimalSeparator, '.');
            price = parseFloat(price);

          switch (planName) {
                case '0':
                case '3':
                    price /= 30;
                    break;
                case '2':
                case '4':
                    price /= 90;
                    break;
                case '5':
                    price /= 180;
                    break;
                case '1':
                case '6':
                    price /= 365;
                    break;
                default:
                    console.error('Invalid plan name');
                    return priceString;
            }
    
            return `${currencySymbol}${price.toFixed(2)}`;
        } else {
            console.error('Invalid price string');
            return priceString;
        }
    };

    const onSubscriptionItemClick = (item, subscriptionItems, container) => {
        subscriptionItems.forEach((i) => {
            toggleClass(i, 'selected', i === item);
            updateAttribute(i.querySelector('button'), 'aria-expanded', i === item ? 'true' : 'false');
        });
    
        const form = item.closest('form[action*="/cart/add"]');
        if (item.querySelector('.subscription-widget__item-onetime')) {
            if (item.querySelector('.subscription-widget__selectors')) {
                const selectedItem = item.querySelector('.subscription-widget__selectors-radio-subscriptions[data-checked]');
                selectedItem ? selectedItem.click() : clickOneJarLabel(container);
            } else {
                if (form) {
                    updateFormInputs(form, item.querySelector('label').getAttribute('variant-id'), '');
                    updatePrice(item, item.querySelector('.subscription-widget__item-price').textContent);
                    toggleSaveUpToMessage(item, true);
                    updateFormDataIndex(form, "0");
                }
            }
        } else if (item.querySelector('.subscription-widget__item-subscribe')) {
            const selectedItem = item.querySelector('.subscription-widget__selectors-radio-subscriptions[data-checked]');
            selectedItem ? selectedItem.click() : clickOneMonthLabel(container);
            toggleSaveUpToMessage(item, false);
        }
    };

    // const onSubscriptionItemClick = (item, subscriptionItems, container) => {
    //     subscriptionItems.forEach((i) => {
    //         toggleClass(i, 'selected', i === item);
    //         updateAttribute(i.querySelector('button'), 'aria-expanded', i === item ? 'true' : 'false');
    //     });

    //     const form = item.closest('form[action*="/cart/add"]');
    //     if (item.querySelector('.subscription-widget__item-onetime')) {
    //         if (form) {
    //             updateFormInputs(form, item.querySelector('label').getAttribute('variant-id'), '');
    //             updatePrice(item, item.querySelector('.subscription-widget__item-price').textContent);
    //             toggleSaveUpToMessage(item, true);
    //             updateFormDataIndex(form, "0");
    //         }
    //     } else if (item.querySelector('.subscription-widget__item-subscribe')) {
    //         const selectedItem = item.querySelector('.subscription-widget__selectors-radio-subscriptions[data-checked]');
    //         selectedItem ? selectedItem.click() : clickOneMonthLabel(container);
    //         toggleSaveUpToMessage(item, false);

    //     }
    // };

    const onSubscriptionLabelClick = (label) => {
        const radioGroupWrapper = label.parentElement;
        radioGroupWrapper.querySelectorAll('.subscription-widget__selectors-radio-subscriptions').forEach((radio) => {
            radio.removeAttribute('data-checked');
        });

        const radioSubscriptions = label.querySelector('.subscription-widget__selectors-radio-subscriptions');
        radioSubscriptions.setAttribute('data-checked', '');

        const form = label.closest('form[action*="/cart/add"]');
        const itemWrap = label.closest('.subscription-widget__item-wrap');
        if (form && itemWrap) {
            updateFormInputs(form, label.getAttribute('data-variant-id'), label.getAttribute('data-selling-plan-id'));
            updateServingPrice(label);
            updatePrice(itemWrap, label.getAttribute('data-price'));
            updateFormDataIndex(form, label.getAttribute('data-index'));

            const frequencyText = itemWrap.querySelector('.subscription-widget__selectors-info-items-fequency');
            if (frequencyText) {
                frequencyText.innerHTML = label.getAttribute('data-plan-desc');
            }
        }
    };

    const addClickListeners = (container, selector, handler) => {
        const elements = container.querySelectorAll(selector);
        elements.forEach((element) => {
            if (!element.hasAttribute('data-click-listener-added')) {
                element.addEventListener('click', handler);
                element.setAttribute('data-click-listener-added', 'true');
            }
        });
    };

    const initSubscriptionWidget = (widgetId) => {
        const widgetContainers = document.querySelectorAll(`.subscription-widget[data-widget-id="${widgetId}"]`);
        widgetContainers.forEach((widgetContainer) => {
            if (!widgetContainer.getAttribute('data-widget-initiated')) {
              addClickListeners(widgetContainer, '.subscription-widget__item', (event) => {
                  const item = event.currentTarget;
                  const subscriptionItems = widgetContainer.querySelectorAll('.subscription-widget__item');
                  onSubscriptionItemClick(item, subscriptionItems, widgetContainer);
              });
  
              addClickListeners(widgetContainer, '.subscription-widget__selectors-label', (event) => {
                  event.stopPropagation();
                  onSubscriptionLabelClick(event.currentTarget);
              });
  
              clickSubscriptionPlan(widgetContainer);
              clickOneJarLabel(widgetContainer);
              clickOneMonthLabel(widgetContainer);
  
              widgetContainer.setAttribute('data-widget-initiated', 'true');
          }
        })
    };

    const clickSubscriptionPlan = (widgetContainer) => {
        const subscribeButton = widgetContainer.querySelector('.subscription-widget__item-subscribe');
        if (subscribeButton) {
            subscribeButton.click();
        }
    };

    const clickOneMonthLabel = (widgetContainer) => {
        const oneMonthLabel = widgetContainer.querySelector('.subscription-widget__selectors-label[data-index="3"]');
        if (oneMonthLabel) {
            oneMonthLabel.click();
        }
    };

  
      const clickOneJarLabel = (widgetContainer) => {
        const oneJarLabel = widgetContainer.querySelector('.subscription-widget__selectors-label[data-index="0"]');
        if (oneJarLabel) {
            oneJarLabel.click();
        }
    };
    // Subscription Selector Methods End



    document.addEventListener('DOMContentLoaded', () => {
        // Read More Start
        let drawerToggles = document.querySelectorAll('[data-drawer-toggle-custom]');
        let drawers = document.querySelectorAll('[data-drawer-custom]');
        let drawerOverlays = document.querySelectorAll('.drawer__overlay');
        let header = document.querySelector('#SiteHeader');
      
        // CartDrawer Upgrade To Subscription Start
        if (window.location.href.includes('/cart')) {
          let subscriptionButtons = document.querySelectorAll('.subscription-button');
          subscriptionButtons.forEach(function(button) {
              if (button.getAttribute('data-click-added') === null) {
                  button.setAttribute('data-click-added', '');
                  button.addEventListener('click', function(e) {
                      e.preventDefault();
                      let optionsContainer = this.nextElementSibling;
                      let selectElement = optionsContainer.querySelector('.subscription-select');
                      optionsContainer.style.display = 'block';
                      selectElement.style.display = 'block';
                      this.style.display = 'none';
                      this.classList.add('is-loading');
                      selectElement.showPicker();
                  });
              }
          });
          
          let subscriptionSelects = document.querySelectorAll('.subscription-select');
          subscriptionSelects.forEach(function(select) {
              select.setAttribute('data-initial-value', select.value);
          
              select.addEventListener('change', function() {
                  let initialValue = this.getAttribute('data-initial-value');
                  console.log('promjena', this, this.value, initialValue);
                  if (this.value !== initialValue) {
                      let cartItemID = this.closest('.upgrade-to-subscription').getAttribute('data-line-item-id');
                      let selectedPlanID = this.value;
                      let variantId = this.querySelector('option:checked').getAttribute('data-variant-id');
                      fetch('/cart/change.js', {
                          method: 'POST',
                          headers: {
                              'Content-Type': 'application/json',
                          },
                          body: JSON.stringify({
                              id: cartItemID,
                              quantity: 0
                          }),
                      })
                      .then(response => {response.json(); console.log('response');})
                      .then(data => {
                        console.log('data', data);
                          fetch('/cart/add.js', {
                              method: 'POST',
                              headers: {
                                  'Content-Type': 'application/json',
                              },
                              body: JSON.stringify({
                                  items: [{
                                      id: variantId,
                                      quantity: 1,
                                      selling_plan: selectedPlanID
                                  }]
                              }),
                          })
                          .then(response => response.json())
                          .then(data => {
                              location.reload();
                          })
                          .catch(error => {
                              console.error('Error adding item to cart:', error);
                          });
                      })
                      .catch(error => {
                          console.error('Error updating cart:', error);
                      });
          
                      this.style.display = 'none';
                      this.closest('.upgrade-to-subscription').querySelector('.subscription-button').style.display = 'block';
                      this.closest('.subscription-options-container').style.display = 'none';
          
                      this.setAttribute('data-initial-value', this.value);
                  }
              });
          });
        }
        // CartDrawer Upgrade To Subscription END
        
        drawerToggles.forEach((toggle) => {
            toggle.addEventListener('click', () => {
                let drawerId = toggle.getAttribute('aria-controls');
                let drawer = document.getElementById(drawerId);

                if (drawer) {
                    let isHidden = drawer.getAttribute('aria-hidden') === 'true';
                    drawer.setAttribute('aria-hidden', !isHidden);

                    if (isHidden) {
                        drawer.classList.add('is-open');
                        document.body.classList.add('js-drawer-open');
                        lockScrollReadMore();
                    } else {
                        drawer.classList.remove('is-open');
                        document.body.classList.remove('js-drawer-open');
                        unlockScrollReadMore();
                    }
                }
            });
        });

        drawerOverlays.forEach((overlay) => {
            overlay.addEventListener('click', () => {
                let drawer = document.querySelector('.product__popup.drawer.is-open[data-drawer-custom]');
                if (drawer) {
                    drawer.setAttribute('aria-hidden', 'true');
                    drawer.classList.remove('is-open');
                    document.body.classList.remove('js-drawer-open');
                    unlockScrollReadMore();
                }
            });
        });
        // Read More End

        // Upsell Cart Start
        const upsellProduct = document.querySelector('.cdk-upsell-product.upsell-product');
        const upsellForm = document.querySelector('form[data-upsell-selector="upsell_additional_enabled"], form[data-upsell-selector="upsell_enabled"]');

        if (upsellProduct && upsellForm) {
            let addToCartButton = upsellForm.querySelector('.MAINBUTTON[data-add-to-cart]');
            addToCartButton.setAttribute('data-upsell-drawer-click', false);
            addToCartButton.addEventListener('click', (event) => {
                if (upsellForm && addToCartButton.getAttribute('data-upsell-drawer-click') == 'false') {
                    event.preventDefault();
                    event.stopPropagation();
                    if (upsellProduct) {
                        upsellProduct.classList.add('is-open');
                    }
                    lockScrollUpsell();
                } else {
                    addToCartButton.setAttribute('data-upsell-drawer-click', false);
                }
            });

            const upsellCase = upsellForm.getAttribute('data-upsell-selector');
            const upsellCloseButton = document.querySelector('.cart-drawer__close.upsell-close');
            const drawerOverlays = document.querySelectorAll('.drawer__overlay');
            const upsellButton = document.querySelector('.addUpsell_product');
            const normalButton = document.querySelector('.addNormal_product');

            if (upsellCloseButton) {
                upsellCloseButton.addEventListener('click', () => {
                    upsellProduct.classList.remove('is-open');
                    unlockScrollUpsell();
                });
            }

            drawerOverlays.forEach((overlay) => {
                overlay.addEventListener('click', () => {
                    if (upsellProduct.classList.contains('is-open')) {
                        addToCartButton.setAttribute('data-upsell-drawer-click', true);
                        addToCartButton.click();
                        upsellProduct.classList.remove('is-open');
                        unlockScrollUpsell();
                    }
                });
            });

            if (upsellButton && upsellForm) {
                upsellButton.addEventListener('click', (event) => {
                    event.preventDefault();
                    const index = upsellForm.getAttribute('data-selected-item-index');
                    getBundleProductData(index, upsellCase, addToCartButton);
                    upsellProduct.classList.remove('is-open');
                    unlockScrollUpsell();
                });
            }

            if (normalButton && upsellForm) {
                normalButton.addEventListener('click', (event) => {
                    event.preventDefault();
                    addToCartButton.setAttribute('data-upsell-drawer-click', true);
                    addToCartButton.click();
                    upsellProduct.classList.remove('is-open');
                    unlockScrollUpsell();
                });
            }
        }
        // Upsell Cart End

        // Subscription Selector Start
        const initializeWidgets = () => {
            document.querySelectorAll('.subscription-widget').forEach((widget) => {
                const widgetId = widget.getAttribute('data-widget-id');
                initSubscriptionWidget(widgetId);
            });
        };

        const observer = new MutationObserver((mutations) => {
            mutations.forEach((mutation) => {
                if (mutation.addedNodes.length > 0) {
                    mutation.addedNodes.forEach((node) => {
                        if (node.nodeType === Node.ELEMENT_NODE && node.classList.contains('pswp__zoom-wrap')) {
                            const subscriptionWidgets = node.querySelectorAll('.subscription-widget');
                            subscriptionWidgets.forEach((subscriptionWidget) => {
                              if (subscriptionWidget) {
                                initializeWidgets();
                              }
                            })

                        } else if (node.nodeType === Node.ELEMENT_NODE && node.classList.contains('subscription-widget')) {
                            initializeWidgets();
                        }
                    });
                }
            });
        });

        const observeConfig = {
            childList: true,
            subtree: true
        };
        observer.observe(document.body, observeConfig);
        initializeWidgets();
        // Subscription Selector End

    });

    // ^^ Keep your scripts inside this IIFE function call to
    // avoid leaking your variables into the global scope.
})();